import * as React from "react";
import darken from "polished/lib/color/darken";
import styled from "../../../styled/index";
const ScrollListItemComponent = styled("div") `
  width: 100%;
  padding: 8px 15px;
  cursor: pointer;
  background: ${({ theme }) => theme.input.background};
  border-bottom: 1px solid ${({ theme }) => theme.input.border};
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: ${({ theme }) => darken(0.07, theme.input.background)};
  }
`;
const ScrollListComponent = styled("div") `
  display: block;
  height: ${({ height }) => height === null ? "auto" : `${height}px`};
  overflow: auto;
  width: 100%;
  background: ${({ theme }) => theme.input.background};
  color: ${({ theme }) => theme.input.text};
  border: ${({ version, theme }) => version === 'v2' ? "none" : `1px solid ${theme.input.border}`} ;
  border-radius: 3px;
`;
export const ScrollListItem = (props) => React.createElement(ScrollListItemComponent, { ...props });
export class ScrollList extends React.Component {
    render() {
        const { height, version } = this.props;
        return (React.createElement(ScrollListComponent, { height: height, style: { transform: "translate3d(0, 0, 0)" }, version: version }, this.props.children));
    }
}
//# sourceMappingURL=index.js.map